import type { DriverType } from '@/types';

/**
 * Whether the driver speaks a document query language (mongosh) vs SQL.
 * Branches the Monaco editor mode, the autocomplete provider, and the
 * TableView WHERE/ORDER BY input shape. New document drivers (Cassandra,
 * Elasticsearch — Phase 22+) join the list here.
 */
export function isDocumentDriver(driverType: DriverType): boolean {
  return driverType === 'mongodb';
}

/** Monaco language id for a given driver. SQL drivers use `sql`; document
 *  drivers use `javascript` so users get mongosh-style highlighting + the
 *  standard JS bracket/string matching. */
export function getEditorLanguage(driverType: DriverType): 'sql' | 'javascript' {
  return isDocumentDriver(driverType) ? 'javascript' : 'sql';
}
